import { useInView } from 'react-intersection-observer';

const useObserver = (options = {}) => {
    const { ref, inView, entry } = useInView(options);
    return { ref, inView, entry };
};

export default useObserver;
